import { inject } from 'dependable-react';
import React from 'react';

import { APP_DATA_TOKEN } from '../../../services/InjectTokens';
import { PhotoFrame } from '../../PhotoFrame';

export const Images = ({ images }: any) => {
  const appState = inject(APP_DATA_TOKEN);
  const childImage = appState.childImage;
  const dedicationImage = appState.dedicationImage;

  // handle images load
  return (
    <div>
      {images.map((image: any, j: number) => {
        const isChildPhotoFrame = image.image.smallUrl.includes('child_photo_frame');
        const isDedicationPhotoFrame = image.image.smallUrl.includes('dedication_photo_frame');

        if (isChildPhotoFrame && !childImage) {
          return null;
        }
        if (isDedicationPhotoFrame && !dedicationImage) {
          return null;
        }
        if (isChildPhotoFrame && childImage) {
          return <PhotoFrame key={`image-page-${j.toString()}`} image={image} imageSrc={childImage.path} />;
        }
        if (isDedicationPhotoFrame && dedicationImage) {
          return <PhotoFrame key={`image-page-${j.toString()}`} image={image} imageSrc={dedicationImage.path} />;
        }

        return (
          <img
            src={image.image.smallUrl}
            key={`image-page-${j.toString()}`}
            alt="Image"
            style={{
              borderBottomWidth: `${image.borderBottomWidth}mm`,
              borderLeftWidth: `${image.borderLeftWidth}mm`,
              borderRightWidth: `${image.borderRightWidth}mm`,
              borderTopWidth: `${image.borderTopWidth}mm`,
              height: `${image.height}mm`,
              left: `${image.left}mm`,
              position: 'absolute',
              top: `${image.top}mm`,
              transform: `rotateZ(${image.rotation}deg)`,
              width: `${image.width}mm`,
              zIndex: 5,
            }}
          />
        );
      })}
    </div>
  );
};
